<template>
    <div class="col backgroundForm">
        <div class="col-12 col-md-10 offset-md-1">
            <h3 class="col-12" align="center">Formulario de Renovacion de Matricula </h3>
            <h5 class="col-12" align="center">CAPITANIA {{ cSessionUser.name_port }} </h5>
        </div>
        <table class="table">
            <tr>
                <td align="left"><b>n=</b>{{ values_renew.n_factor_time }} <br> <b>dias posteriores al vencimiento:</b> {{ values_renew.days > 0 ? values_renew.days : 0 }}</td>
                <td align="rigth">
                    <b>UFV=</b>{{ values_renew.ufv }}
                    <b>C=</b>{{ values_renew.cut }}
                    <b>N=</b>{{ values_renew.activity }}
                    <b>P=</b>{{ values_renew.propulsion }}<br>
                    <span v-if="values_renew.multa==='S'"><b>Importe Renovacion sin multa=</b> {{ values_renew.importe_no_multa }}</span>                    
                </td>
            </tr>            
        </table>
        
        <div class="row">
            <!-- <button class="btn btn-outline-primary col-12 col-md-2 offset-md-1"><font-awesome-icon icon="print" /> Proforma</button> -->
            <div class="col-12 col-md-6">
                <table class="table table-sm">
                    <thead class="thead-dark">
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">DETALLE</th>
                            <th scope="col">IMPORTE</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(d, i) in dts_renew" :key="d.i">
                            <td>{{ (i+1) }}</td>
                            <td>{{ d.glosa }}</td>
                            <td v-if="d.multa==='S'">{{ (aux_imp_solo_multa)-(aux_imp_sin_multa) }}</td>
                            <td v-else>{{ aux_imp_sin_multa }}</td>
                        </tr>
                        <tr class="table-success">
                            <td colspan="2" align="center"><b>TOTAL</b></td>
                            <td><b>{{ total_renew }}</b></td>
                        </tr>
                        <tr>
                            <td colspan="3">
                                <div class="form-row" v-if="autImport==='S' && d_btn_status_renew" >
                                    <button class="btn btn-outline-danger col-md-1 offset-md-5" @click="mEditImport('R')"><font-awesome-icon icon="minus-circle" /></button>           
                                    <button class="btn btn-outline-danger col-md-1" @click="mEditImport('I')"><font-awesome-icon icon="plus" /></button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                
            </div>
            <div class="col-6 col-md-2">
                <!-- <button class="btn btn-outline-info btn-lg"><font-awesome-icon icon="file-pdf" size="lg" @click="mGetCotizacion"/>Proforma</button> -->
                <h5 class="mb-0">
                    <button v-if="d_btn_status_renew" class="btn btn-outline-primary btn-block"  @click="mGetCotizacion">
                        <font-awesome-icon icon="file-pdf" size="3x" /><br>Proforma 
                    </button>
                    <button v-else class="btn btn-outline-dark btn-block" @click="mSendHome"><font-awesome-icon icon="home" size="3x" /><br>Inicio</button>
                </h5>
            </div>
            <div class="col-6 col-md-2 offset-md-1">
                <h5 class="mb-0">
                    <button v-if="d_btn_status_renew" class="btn btn-outline-danger btn-block"  @click="mApproveCotizacion">
                        <font-awesome-icon icon="check" size="3x" /><br>Renovar 
                    </button>
                    <!-- <button class="btn btn-outline-danger"><font-awesome-icon icon="check" size="3x"/> <br>Renovar</button> -->
                </h5>
                
            </div>
        </div>
        <br>

        <div>
            <div class="form-row">
                <div class="form-group col-12 col-md-6">
                    <label for="name-ship">Nombre Nave</label>
                    <input type="text" disabled :value="cShipRenew.name" class="form-control">
                </div>
                <div class="form-group col-12 col-md-6">
                    <label for="name-ship">Matricula</label>
                    <input v-if="cShipRenew.enrollment" type="text" disabled :value="cShipRenew.enrollment" class="form-control">
                    <input v-else type="text" disabled :value="cShipRenew.old_enrollment" class="form-control">
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-6 col-md-3">
                    <label for="name-ship">TRB</label>
                    <input type="text" disabled :value="cShipRenew.trb" class="form-control">
                </div>
                <div class="form-group col-6 col-md-3">
                    <label for="name-ship">TRN</label>
                    <input type="text" disabled :value="cShipRenew.trn" class="form-control">
                </div>
                <div class="form-group col-12 col-md-6">
                    <label for="name-ship">Tipo embarcacion</label>
                    <input type="text" disabled :value="cShipRenew.type_ship" class="form-control">
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-12 col-md-6">
                    <label for="name-ship">Propulsion</label>
                    <input type="text" disabled :value="factors.propulsion" class="form-control">
                </div>
                <div class="form-group col-12 col-md-6">
                    <label for="name-ship">Navegacion</label>
                    <input type="text" disabled :value="factors.destino_nave" class="form-control">
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-12 col-md-6">
                    <label for="name-ship">Fecha de Vencimiento</label>
                    <input type="text" disabled :value="cShipRenew.date_expiration" class="form-control">
                </div>
            </div>

            <div class="form-row">
                <div class="form-group col-12 col-md-6">
                    <label for="name-ship">Propietario</label>
                    <input type="text" disabled :value="owner_dts.name_property ? owner_dts.name_property: 'Sin registro'" class="form-control">
                </div>
                <div class="form-group col-12 col-md-6">
                    <label for="name-ship">Identificacion</label>
                    <input type="text" disabled :value="owner_dts.data_identification ? owner_dts.data_identification: 'Sin registro'" class="form-control">
                </div>
            </div>

        </div>
        

        <div style="display:none" id="printProforma">
            <div class="alert" align="center"><b>PROFORMA</b></div>
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th><b>NAVE</b></th>
                        <th><b>MATRICULA</b></th>
                        <th><b>TIPO EMBARCACION</b></th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{{ cShipRenew.name }}</td>
                        <td v-if="cShipRenew.enrollment">{{cShipRenew.enrollment}}</td>
                        <td v-else>{{cShipRenew.old_enrollment}}</td>
                        <td>{{ cShipRenew.type_ship }}</td>
                    </tr>
                </tbody>
            </table>

            <table class="table">
                <thead>
                    <tr>
                        <th><b>#</b></th>
                        <th><b>DETALLE</b></th>
                        <th><b>IMPORTE</b></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(d, i) in dts_renew" :key="d.i">
                        <td>{{ (i+1) }}</td>
                        <td>{{ d.glosa }}</td>
                        <td v-if="d.multa==='S'">{{ (aux_imp_solo_multa)-(aux_imp_sin_multa) }}</td>
                        <td v-else>{{ aux_imp_sin_multa }}</td>
                    </tr>
                    <tr class="table-success">
                        <td colspan="2" align="center"><b>TOTAL</b></td>
                        <td><b>{{ total_renew }}</b></td>
                    </tr>
                </tbody>
            </table>
            <small class="form-text text-muted">{{ day }}</small>
            <small class="form-text text-muted" v-if="values_renew.days > 0" >Actualmente la embarcacion {{ cShipRenew.name }} cuenta con <b>{{ values_renew.days }} dias </b> de retraso a la fecha de vencimiento de su matricula </small>
            <small class="form-text text-muted"><b>Nota:</b> La cotizacion expedida tiene vigencia en el mismo dia de su emision por lo que se sugiere tomar las previsiones correspondientes, ya que estan sujetas a cambio de valor por la fecha de su emision.</small>
        </div>

        <modal-loading :id-modal="id_modal_l" :title="load_title" :status-send="load_status"></modal-loading>
        <modal-report :id-modal-report="id_modal_r" :title="modal_report_t" :content="modal_report_c" :url-r="modal_report_url" :id-report="id_report"></modal-report>
    </div>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';
const qs=require('qs');

import modalReport from '../modal/modalReport'
import modalLoading from '../modal/modalLoading'


export default {
    name:'renew',
    data(){
        return{
            port_local:[],
            dRolUser:false,
            id_modal_l:'loadingRenew',
            load_title:null,
            load_status:'Cargando',
            id_modal_r:'reportRenew',
            modal_report_t:'Renovacion de Matricula',
            modal_report_c:null,
            modal_report_url:'pdfRenew',
            id_report:0,
            owner_dts:[],
            factors:[],
            dts_renew:[],
            total_renew:0,
            output:null,
            day:null,
            d_btn_status_renew:true,
            values_renew:{
                cut:0,
                ufv:0,
                activity:0,
                propulsion:0,
                n_factor_time:0,
                days:0,
                multa:'N',
                importe_no_multa:0
            },
            autImport:'N',
            importe_aux:{
                sm:0,
                cm:0
            },
            aux_imp_solo_multa:0,
            aux_imp_sin_multa:0

        }
        
    },
    created:function(){
        return this.cShipRenew.name ? true:this.$router.push('renew-ship');
    },
    mounted(){
        this.chargeInit()
    },
    methods:{
        async chargeInit(){
            this.autImport=Vue.auth.getAutImp();
            //   llamar al loading hasta esperar que complete todos los datos del formulario hacer lo mismo en la aprobacion de la matricula
            this.load_title='Cargando';
            this.mGetDay();
            this.mShowModal(this.id_modal_l);
            try{
                // let owner = await axios.get(`getOwnerShip/${this.cShipRenew.id_ship}`);
                // let factor = await axios.get(`getFactorShip/${this.cShipRenew.id_ship}`);
                // let cotizacion = await axios.get(`getRenewShip/${this.cShipRenew.id_ship}`);
                let owner = await axios.get(`getOwnerShip/${this.cShipRenew.id_ship}?api_token=${Vue.auth.getToken()}`);
                let factor = await axios.get(`getFactorShip/${this.cShipRenew.id_ship}?api_token=${Vue.auth.getToken()}`);
                let cotizacion = await axios.get(`getRenewShip/${this.cShipRenew.id_ship}?api_token=${Vue.auth.getToken()}`);
                // console.log(owner)
                // console.log(factor.data[0])
                // console.log(factor.data.length)
                console.log(cotizacion.data);
                
                this.dts_renew=cotizacion.data;


                
                this.values_renew.cut=this.dts_renew[0].cut;
                this.values_renew.ufv=this.dts_renew[0].ufv;
                this.values_renew.activity=this.dts_renew[0].N;
                this.values_renew.propulsion=this.dts_renew[0].P;
                this.values_renew.n_factor_time=this.dts_renew[0].n;
                this.values_renew.days=this.dts_renew[0].dias_retrasos;
                this.values_renew.multa=this.dts_renew[0].multa;
                this.values_renew.importe_no_multa=this.dts_renew[0].imp_no_multa;

                // console.log(this.dts_renew[0].importe);
                if(owner.data.length > 0){
                    this.owner_dts=owner.data[0];
                }else{
                    this.owner_dts=[];
                }
                if(factor.data.length > 0){
                    this.factors=factor.data[0];
                }else{
                    this.factors=[];
                }
                setTimeout(()=>{
                    this.mCalcRenew()
                    this.mHideModal(this.id_modal_l);
                },2000)
            }catch(error){
                console.log(error);
                setTimeout(()=>{
                    this.mHideModal(this.id_modal_l);
                },2000)
            }
            
            
        },
        mSelectShip(){
            // console.log('pasando a la siguiente ventana');
            this.$router.push('discharge-document');
        },
        mShowModal(id){
            $('#'+id).modal('show');
        },
        mHideModal(id){
            $('#'+id).modal('hide');
        },
        mCalcRenew(){
            let s=0;
            this.aux_imp_solo_multa=0;
            this.aux_imp_sin_multa=0;
            this.dts_renew.forEach((dts_r)=>{
                if(dts_r.multa==='S'){
                    this.aux_imp_solo_multa=dts_r.importe;
                }
                if(dts_r.multa==='N'){
                    this.aux_imp_sin_multa=dts_r.importe;
                }
            })
            this.total_renew=this.aux_imp_solo_multa>0 ? this.aux_imp_solo_multa:this.aux_imp_sin_multa;
        },
        mEditImport(t='I'){
            let aux_imp=0;

            if(this.importe_aux.sm===0){
                let idxsm=this.dts_renew.findIndex(dti=> dti.multa==='N' );
                this.importe_aux.sm= parseFloat(this.dts_renew[idxsm].importe)*0.5;
            }
            if(this.importe_aux.cm===0){
                let idxcm=this.dts_renew.findIndex(dti=> dti.multa==='S' );
                if(idxcm>-1){
                    this.importe_aux.cm= parseFloat(this.dts_renew[idxcm].importe)*0.5;
                }
            }
            switch(t){
                case 'I':
                    // incrementamos el importe ya establecido
                    // console.log(`incremento el valor ${this.dts_renew[0].importe}`)
                    // aux_imp=parseFloat(this.dts_renew[0].importe)+aux_i;
                    this.dts_renew.forEach((dtr)=>{
                        if(dtr.multa==='S'){
                            aux_imp=parseFloat(dtr.importe)+this.importe_aux.cm;
                            dtr.importe=aux_imp;
                        }
                        if(dtr.multa==='N'){
                            aux_imp=parseFloat(dtr.importe)+this.importe_aux.sm;
                            dtr.importe=aux_imp;
                        }
                        // this.dts_renew[0].importe=aux_imp;
                    })
                    this.mCalcRenew();
                    break;
                case 'R':
                    // restamos el importe sugerido
                    // console.log(`decremento el valor ${this.dts_renew[0].importe}`)
                    this.dts_renew.forEach((dtr)=>{
                        if(dtr.multa==='S'){
                            aux_imp=parseFloat(dtr.importe)-this.importe_aux.cm;
                            if(aux_imp>0){
                                dtr.importe=aux_imp;
                            }
                        }
                        if(dtr.multa==='N'){
                            aux_imp=parseFloat(dtr.importe)-this.importe_aux.sm;
                            if(aux_imp>0){
                                dtr.importe=aux_imp;                                
                            }
                        }
                        // this.dts_renew[0].importe=aux_imp;
                    })
                    this.mCalcRenew();
                    break;
            }
        },
        mGetCotizacion(){

            this.$htmlToPaper('printProforma');
        },
        mSendHome(){
            this.$router.push('renew-ship');
        },
        async mApproveCotizacion(){
            this.load_title='Renovando';            
            this.mShowModal(this.id_modal_l);

            // let url=`sendRenew`;
            let url=`sendRenew?api_token=${Vue.auth.getToken()}`;
            
            let new_register=[];
            let suma_total=0;
            
            let idsm=this.dts_renew.findIndex( dtb => dtb.multa==='N');
            let impsm=idsm>-1 ? this.dts_renew[idsm].importe:0;

            let idcm=this.dts_renew.findIndex( dtb => dtb.multa==='S');
            let impcm=idcm>-1 ? this.dts_renew[idcm].importe:0;

            // console.log(impcm)
            // console.log(impsm)

            this.dts_renew.forEach((dtn)=>{
                let aux;
                if(dtn.multa ==='S'){
                    aux={
                        importe: parseInt(dtn.importe) - parseInt(impsm),
                        code_renew:dtn.code_renew,
                        glosa:dtn.glosa
                    }
                    console.log(`el valor de con multa es `)
                    console.log(aux);
                    new_register.push(aux);

                }

                if(dtn.multa ==='N'){
                    aux={
                        importe: dtn.importe,
                        code_renew:dtn.code_renew,
                        glosa:dtn.glosa
                    }
                    console.log(`el valor de importe sin multa es `)
                    console.log(aux);
                    new_register.push(aux);

                }

            })
            
            // console.log(new_register);
            
            suma_total=impcm>0 ? impcm:impsm;
            
            let head_aux={
                id_ship:this.cShipRenew.id_ship,
                total:suma_total,
                ufv:this.values_renew.ufv
            }
            let params={
                head:JSON.stringify(head_aux),
                body:JSON.stringify(new_register)
            }
            // let send=JSON.stringify(params)
            
            let register=await axios.post(url, qs.stringify(params));
            // console.log(register);
            let response=register.data;
            setTimeout(()=>{            
                this.mHideModal(this.id_modal_l);
                this.d_btn_status_renew=false;
                if(!response.error){
                    
                    toastr.success(`${response.respuesta}`, 'Exito');
                    // llamar a la ventana de modal de reporte
                    this.id_report=response.tr;
                    this.modal_report_c=response.respuesta;
                    
                    this.mShowModal(this.id_modal_r);
                }else{
                    toastr.danger(`${response.respuesta}`, 'Error');
                }
            },2000)
            
        },
        mGetDay(){
            let meses = new Array ("Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre");
            let diasSemana = new Array("Domingo","Lunes","Martes","Miércoles","Jueves","Viernes","Sábado");
            let f=new Date();
            this.day=diasSemana[f.getDay()] + ", " + f.getDate() + " de " + meses[f.getMonth()] + " de " + f.getFullYear();
        }
    },
    computed:{
        cSessionUser(){
            return this.$store.getters.getUserState;
        },
        cShipRenew(){
            return this.$store.getters['sShipRenew/getShipRenew'];
        },
        cUfv(){
            return this.$store.getters.getUFV;
        }
    },
    components:{
        'modal-report':modalReport,
        'modal-loading':modalLoading
    }
}
</script>

<style>

</style>




// WEBPACK FOOTER //
// src/components/renew/SendRenew.vue